import React, { useState, useEffect } from "react";
import { Drawer, List, ListItemButton, ListItemText, Collapse, CircularProgress } from "@mui/material";
import { ExpandLess, ExpandMore, Dashboard, Storefront } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axiosInstance from "./axiosInstance";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_URL;

const Sidebar = () => {
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openCategories, setOpenCategories] = useState({});

  useEffect(() => {
    fetchSidebarMenu();
  }, []);

  const fetchSidebarMenu = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/login", { replace: true });
        return;
      }

      const response = await axiosInstance.get(`${apiUrl}/pages`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMenuItems(response.data.pages);
      setOpenCategories(
        response.data.pages.reduce((acc, category) => {
          acc[category.category] = false; // Initialize collapsed
          return acc;
        }, {})
      );
    } catch (error) {
      toast.error("Failed to load menu items");
    } finally {
      setLoading(false);
    }
  };

  const toggleCategory = (category) => {
    setOpenCategories((prev) => ({ ...prev, [category]: !prev[category] }));
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 240,
        flexShrink: 0,
        "& .MuiDrawer-paper": { width: 240, boxSizing: "border-box" },
      }}
    >
      {loading ? (
        <CircularProgress sx={{ margin: "auto", mt: 2 }} />
      ) : (
        <List>
          {menuItems.map(({ category, pages }) => {
            // Check if category has only one page & should be directly clickable
            if (pages.length === 1) {
              return (
                <ListItemButton key={pages[0].route} onClick={() => navigate(pages[0].route)}>
                  {category === "Dashboard" ? <Dashboard sx={{ marginRight: 2 }} /> : <Storefront sx={{ marginRight: 2 }} />}
                  <ListItemText primary={pages[0].name} />
                </ListItemButton>
              );
            }

            // If category has multiple pages, show collapsible menu
            return (
              <React.Fragment key={category}>
                <ListItemButton onClick={() => toggleCategory(category)}>
                  <Storefront sx={{ marginRight: 2 }} />
                  <ListItemText primary={category} />
                  {openCategories[category] ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>

                <Collapse in={openCategories[category]} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {pages
                      .filter(({ menu }) => menu !== false) // Hide items where menu is false
                      .map(({ name, route }) => (
                        <ListItemButton key={route} sx={{ pl: 4 }} onClick={() => navigate(route)}>
                          <ListItemText primary={name} />
                        </ListItemButton>
                      ))}
                  </List>
                </Collapse>
              </React.Fragment>
            );
          })}
        </List>
      )}
    </Drawer>
  );
};

export default Sidebar;
